import { Component } from 'react'
import { Row, FormControl } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import { Container } from '@material-ui/core'
import * as ajax from '../Utilities/ajax'
import Auth from '../Utilities/Auth'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import { FaUserCircle } from 'react-icons/fa'
import { RiLockPasswordFill } from 'react-icons/ri'
import { getUrlQueries } from '../Utilities/url'

const { detect } = require('detect-browser')
const detectResult = detect()

export default class Login extends Component<any> {

  state = {
    forceLoading: false,
    showError: false,
    errorStatus: undefined,
    user: {
      username: undefined,
      password: "nopassword",
    },
    preLogin: false
  }

  apiLogin = async () => {
    this.setState({ forceLoading: true, showError: false })
    return ajax.login(this.state.user.username, this.state.user.password)
      .then(result => {
        Auth.authenticateUser(result.data.token, result.data.roles, this.state.user.username, result.data.data)

        const queries = getUrlQueries()
        if (
          queries.q                           // Publication
          || queries.vid || queries.section   // Video
        ) {
          window.location.reload()
        }
        else {
          window.location.pathname = Auth.isAdmin(result.data.roles) ? '/admin' : '/dashboard'
        }

        if (detectResult) {
          detectResult.username = this.state.user.username
          ajax.post("/video/detectClients", detectResult).then(result => result.data).catch(err => console.log(err))
        }
      })
      .catch(error => {
        this.setState({ forceLoading: false, showError: true })
        alert("Incorrect username and/or password.")
        return error
      })
  }

  handleSubmit = async () => {
    this.setState({ forceLoading: true, showError: false })
    if (!this.state.preLogin) {
      const result = await ajax.preLogin(this.state.user.username).then(result => result.data).catch(err => console.log(err))

      if (!result || result.requirePassword !== false) {
        const { user } = this.state
        user.password = ""
        this.setState({ forceLoading: false, preLogin: true, user })
      }
      else {
        this.setState({ forceLoading: false })
        await this.apiLogin()
      }
    } else await this.apiLogin()
  }

  handleUserInput = (event) => {
    let user = this.state.user
    user[event.target.name] = event.target.value
    this.setState({ user })
  }

  handleKeyPress = (event) => {
    if ((event.keyCode || event.which) === 13) // enter button
      this.handleSubmit()
    else
      this.setState({ showError: false })
  }


  render() {
    let { user } = this.state

    return (
      <div className="login-bg" style={{ backgroundImage: "url('/bg-login2.png')", backgroundSize: "cover" }}>
        <Container maxWidth="sm" className="login-page">
          <Card className="login-from">
            <div>
              <Row style={{ marginTop: 30 }}><img src="/logo2.png" className="img-login" alt="err" /></Row>
              <Row><img src="/user2.png" className="user-login" alt="err" /></Row>
              <CardContent className="content-login" >
                <div className="icons-user">
                  {this.state.preLogin ? <RiLockPasswordFill style={{ color: "#fff" }} /> : <FaUserCircle style={{ color: "#fff" }} />}
                  <div className="border-right"></div>
                </div>
                {!this.state.preLogin ? <FormControl className="input-user" placeholder="กรุณากรอก Username ของท่าน" type="text" value={user.username} name="username" onChange={this.handleUserInput} onKeyDown={this.handleKeyPress} />
                  : <FormControl className="input-user" type="password" placeholder="กรุณากรอก Password ของท่าน" name="password" value={user.password} onChange={this.handleUserInput} onKeyDown={this.handleKeyPress} />}
              </CardContent>
            </div>
            <CardActions className="login-action">
              <Button
                className="button-login"
                style={{ margin: "auto", borderRadius: "20px" }}
                name="btnlogin" block onClick={this.handleSubmit}
                loading={this.state.forceLoading}
              > {this.state.forceLoading ? 'Please wait ..' : 'Login'}
              </Button>
            </CardActions>
          </Card>
        </Container>
      </div>
    )
  }
}
